import React from 'react';
import ReactDOM from 'react-dom';
import i18n from 'i18next';
import backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

import App from './App';

import './index.scss';

// eslint-disable-next-line no-undef
if (process.env.NODE_ENV !== 'production') {
  window._env_ = window._env_ || {};

  // eslint-disable-next-line no-undef
  window._env_.ENVIROMENT = process.env.REACT_APP_ENVIROMENT || 'sibiu';
  window._env_.API_BACKEND_URL = process.env.REACT_APP_API_BACKEND_URL;
  window._env_.VERSION = process.env.REACT_APP_VERSION;
  window._env_.RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
  window._env_.DISABLE_ReCAPTCHA =
    process.env.REACT_APP_DISABLE_ReCAPTCHA || 'false';
  window._env_.ENROLL_EXTERNAL_CARD =
    process.env.REACT_APP_ENROLL_EXTERNAL_CARD || 'false';
  window._env_.ENROLL_BANK_CARD =
    process.env.REACT_APP_ENROLL_BANK_CARD || 'false';
  window._env_.ENABLE_ERP = process.env.REACT_APP_ENABLE_ERP || 'false';
  window._env_.ENABLE_FINES = process.env.REACT_APP_ENABLE_FINES || 'false';
  window._env_.STOCKS_ENABLE = process.env.REACT_APP_STOCKS_ENABLE || 'false';
  window._env_.DYNAMIC_PRICE = process.env.REACT_APP_DYNAMIC_PRICE || 'false';
  window._env_.SCAN_ENABLE = process.env.REACT_APP_SCAN_ENABLE || 'false';
  window._env_.METROPOLITAN_ENABLE =
    process.env.REACT_APP_METROPOLITAN_ENABLE || 'false';
  window._env_.ENABLE_REMOTE_ACTIONS =
    process.env.ENABLE_REMOTE_ACTIONS || 'false';
  window._env_.POS_STATS_ALERT_TiME =
    process.env.REACT_APP_POS_STATS_ALERT_TiME || 0;
  window._env_.DYNAMIC_USER_TYPE =
    process.env.REACT_APP_DYNAMIC_USER_TYPE || 'false';
  window._env_.REACT_APP_SYNC_THOREB =
    process.env.REACT_APP_SYNC_THOREB || 'false';
  window._env_.EDU_ENABLE = process.env.REACT_APP_EDU_ENABLE || 'false';
  window._env_.ERP_PROFORM_ENABLED =
    process.env.REACT_APP_ERP_PROFORM_ENABLED || 'false';
  window._env_.ENABLE_NENOMINAL_PJ_ORDER =
    process.env.REACT_APP_ENABLE_NENOMINAL_PJ_ORDER || 'true';
  window._env_.NENOMINAL_PASS_PERSONS_MAX_COUNT =
    process.env.REACT_APP_NENOMINAL_PASS_PERSONS_MAX_COUNT || '10';
  window._env_.CARD_CATEGORY_IDS_TO_GENERATE_RECEIPT =
    process.env.REACT_APP_CARD_CATEGORY_IDS_TO_GENERATE_RECEIPT || '2, 4';
}

i18n
  .use(backend)
  .use(initReactI18next)
  .init({
    lng: 'ro',
    fallbackLng: 'ro',
    ns: ['translation'],
    defaultNS: 'translation',
    backend: {
      loadPath: '/locales/{{lng}}.json',
    },
    react: {
      useSuspense: false,
    },
  });

ReactDOM.render(<App />, document.getElementById('root'));
